import React, { useMemo } from 'react';
import Chart from 'react-apexcharts';

function BarChart({ data, height = '500px' }) {
  const themeColor = useMemo(() => getComputedStyle(document.body).getPropertyValue('--bs-theme').trim(), []);
  const themeFont = useMemo(() => getComputedStyle(document.body).getPropertyValue('--bs-body-font-family').trim(), []);
  const themeFontWeight = useMemo(() => getComputedStyle(document.body).getPropertyValue('--bs-body-font-weight').trim(), []);
  const gray500 = useMemo(() => getComputedStyle(document.body).getPropertyValue('--bs-gray-500').trim(), []);
  const inverse = useMemo(() => getComputedStyle(document.body).getPropertyValue('--bs-inverse').trim(), []);
  const inverseRgb = useMemo(() => getComputedStyle(document.body).getPropertyValue('--bs-inverse-rgb').trim(), []);
  const borderColor = useMemo(() => getComputedStyle(document.body).getPropertyValue('--bs-border-color').trim(), []);

  const categories = useMemo(() => Object.keys(data), [data]);
  const seriesData = useMemo(() => Object.values(data), [data]);

  const barChartOptions = useMemo(() => ({
    plotOptions: {
      bar: {
        horizontal: true,
        dataLabels: { position: 'top' },
        barWidth: '20%', // This controls the thickness of the bars (you can adjust this)
      },
    },
    dataLabels: {
      enabled: true,
      offsetX: -6,
      style: { fontSize: '12px', colors: ['#ffffff'] },
    },
    colors: [themeColor, gray500],
    stroke: { show: false },
    grid: { borderColor: borderColor },
    xaxis: {
      categories: categories,
      axisBorder: {
        show: true,
        color: 'rgba(' + inverseRgb + ', .25)',
        height: 1,
        width: '100%',
        offsetX: 0,
        offsetY: -1,
      },
      axisTicks: {
        show: true,
        borderType: 'solid',
        color: 'rgba(' + inverseRgb + ', .25)',
        height: 6,
        offsetX: 0,
        offsetY: 0,
      },
      labels: {
        style: {
          colors: inverse,
          fontSize: '12px',
          fontFamily: themeFont,
          fontWeight: themeFontWeight,
          cssClass: 'apexcharts-xaxis-label',
        },
      },
    },
    yaxis: {
      labels: {
        style: {
          colors: inverse,
          fontSize: '12px',
          fontFamily: themeFont,
          fontWeight: themeFontWeight,
          cssClass: 'apexcharts-xaxis-label',
        },
      },
    },
    legend: { fontFamily: themeFont, labels: { colors: inverse } },
    chart: {
      toolbar: {
        tools: {
          download: false,
        },
      },
    },
    tooltip: {
      y: {
        title: {
          formatter: () => '',
        },
      },
    },
  }), [themeColor, gray500, borderColor, inverseRgb, inverse, themeFont, themeFontWeight, categories]);

  const barChartData = useMemo(() => [{ data: seriesData }], [seriesData]);

  return (
    <div className='w-100' style={{ height }}>
      <Chart type='bar' options={barChartOptions} series={barChartData} width='100%' height={height} />
    </div>
  );
}

export default BarChart;
